/**
 * Root route. Declares the router context `createAppRoot` supplies (the auth
 * store and the query client) so every route guard can read the session.
 * `<Toaster>` sits here so the sign-in pages and the shell share one.
 */
import { Outlet, createRootRouteWithContext } from "@tanstack/react-router";
import { Toaster } from "@linkhr/design-system";
import type { RouterContext } from "@linkhr/auth";

export const Route = createRootRouteWithContext<RouterContext>()({
  component: () => (
    <Toaster>
      <Outlet />
    </Toaster>
  ),
});
